import _ from 'lodash';

const pcDefaults = {};
export const productsCompatibilityReducer = (state, _action) => _.cloneDeep(_.assign({}, pcDefaults, state));
